import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import store from '../store/store'
// import user from './modules/user'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import('../views/common/404.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login/login.vue'),
    },
    {
      path: '/',
      name: 'layout',
      redirect: '/home',
      component: () => import('@/views/Index/index.vue'),
      children: [
        {
          path: 'home',
          component: () => import('@/views/home/index'),
        },
      ],
    },
    // {
    //   path: '/',
    //   name: 'layout',
    //   redirect: '/home',
    //   component: () => import('../views/Index/index.vue'),
    //   children: [
    //     {
    //       path: 'home',
    //       component: () =>
    //         import('@/views/home/index'),
    //     },
    // {
    //   path: 'record',
    //   name: 'record',
    //   component: () =>
    //     import('@/views/detail/manage/record.vue'),
    // },
    // {
    //   path: 'interview',
    //   component: () =>
    //     import('@/views/detail/interview/index'),
    // },
    // {
    //   path: 'detection',
    //   component: () =>
    //     import('@/views/detail/detection/index'),
    // },
    // {
    //   path: 'plan',
    //   component: () =>
    //     import('@/views/procure/plan/index'),
    // },
    // {
    //   path: 'proDetail',
    //   component: () =>
    //     import('@/views/procure/proDetail/index'),
    // },
    // {
    //   path: 'proedit',
    //   component: () =>
    //     import('@/views/procure/proDetail/proedit'),
    // },
    // {
    //   path: 'taskPick',
    //   component: () =>
    //     import('@/views/pick/taskPick/index'),
    // },
    // {
    //   path: 'transport',
    //   component: () =>
    //     import('@/views/pick/transport/index'),
    // },
    // {
    //   path: 'warehouse',
    //   component: () =>
    //     import('@/views/pick/warehouse/index'),
    // },
    // {
    //   path: 'skin',
    //   component: () =>
    //     import('@/views/process/skin/index'),
    // },
    // {
    //   path: 'print',
    //   component: () =>
    //     import('@/views/traceability/print/index'),
    // },
    // {
    //   path: 'gistics',
    //   component: () =>
    //     import('@/views/library/logistics/index'),
    // },

    // {
    //   path: 'account',
    //   component: () =>
    //     import('@/views/system/account/index'),
    // },
    // {
    //   path: 'organMsg',
    //   component: () =>
    //     import('@/views/system/organMsg/index'),
    // },
    // {
    //   path: 'menu',
    //   component: () =>
    //     import('@/views/system/menu/index'),
    // },
    // {
    //   path: 'role',
    //   component: () =>
    //     import('@/views/system/role/index'),
    // },
    // {
    //   path: 'dick',
    //   component: () =>
    //     import('@/views/system/dick/index'),
    // },
    //   ]
    // }




  ]
})

const WhiteList = [
  '/404',

]
// '/home'
//  路由守卫


let oneRun = true; //通过oneRun变量控制 避免陷入死循环

router.beforeEach((to, from, next) => {
  console.log(to.path, 'to.path ')
  const token = sessionStorage.getItem("token")
  if (to.path === "/login") {
    next();
  } else {
    const index = WhiteList.findIndex(i => i === to.path)
    if (!token && index === -1) {
      next('/login');
    } else {


      if (oneRun) {
        oneRun = false;
        createNewRouter();
        next({ ...to, replace: true })// 必不可少的，确保你的动态路由创建成功再去执行其它代码
      }

      next();
    }
  }

});
function createNewRouter () {
  const menuList = JSON.parse(sessionStorage.getItem('menuList'))
  let routers = [
    {
      path: '/',
      name: 'layout',
      redirect: '/home',
      component: () => import('@/views/Index/index.vue'),
      children: [
        {
          path: 'home',
          component: () => import('@/views/home/index'),
        },
      ],
    },
  ]
  menuList.forEach((ele) => {
    routers[0].children.push({ path: ele.path, component: () => import(`@/views/${ele.component}`) })
  })
  router.addRoutes(routers)
}
export default router